import {
	CellStyle,
	CellStyleFunc,
	ColDef,
	GridOptions,
} from 'ag-grid-community';
import { AgGridReact, CustomCellRendererProps } from 'ag-grid-react';
import {
	IExportMenuClick,
	IMenuItemExportProps,
} from 'components/buttons/exportButtons/ExportCSVMenuButton';
import {
	IFilterBody,
	ModulesType,
} from 'components/filter/models/TableFilterModels';
import { QueryTypeModule } from 'services/queryClient/wrapperHooks/genericTables/useGetCheckTableDataWithFilters';

import { ViewTableStatus } from '../hooks/useGetDataGridTableWithFilters';
export interface IIsHighlighted {
	isHighlighted: true;
}
export interface IButtonsDefault {
	cancelButton: React.ReactNode;
	updateButton: React.ReactNode;
}
export interface IOnSortChange {
	colId: string;
	sort: 'asc' | 'desc';
}

export type TypeCells = 'number' | 'string' | 'total';
export interface IHeader<Type> {
	field: string;
	headerName: string;
	sortable?: boolean;
	editable?: boolean;
	cellRenderer?: (p: CustomCellRendererProps<Type>) => JSX.Element;
	type?: TypeCells;
	cellStyle?: CellStyle | CellStyleFunc<any, any>;
	enableRowGroup?: boolean;
	enableValue?: boolean;
	aggFunc?: string;
}

export interface ICellEdit<Type> {
	oldValue: number;
	id: string;
	value: number;
	data: Type;
	colName: keyof Type;
}

export interface IAgGridTableProps<Type, BodyType, Params> {
	canEdit: boolean;
	module: QueryTypeModule & ModulesType;
	otherParameters?: Object;
	headers: IHeader<Type>[];
	editable: boolean;
	getIdCellEdit?: (data: Type, col: keyof Type) => string;
	mutate?: (
		cells: Record<string, ICellEdit<Type>>,
		onSuccess: () => void
	) => void;
	isSubmit?: boolean;
	keyDefinedRow?: Array<keyof Type>;
	model?: JSX.Element;
	disabledEditCell?: (colDef: ColDef, data: Type) => boolean;
	convertToBody?: (cells: Record<string, ICellEdit<Type>>) => {
		insert: BodyType[];
		[key: string]: any;
	};
	gridOptions?: GridOptions;
	cellEdit: ICellsEdit<Type>;
	setCellEdit: (cellEdit: ICellsEdit<Type>) => void;
	gridRef: React.RefObject<AgGridReact<any>>;
	filtersMap: IFilterBody[];
	onCancel: () => void;
	renderButtons?: (buttons: IButtonsDefault) => React.ReactNode;
	noDataMessage?: {
		title: string;
		description: string;
	};
	menuList?: IExportMenuClick[] | IMenuItemExportProps<Params>[];
	getNameExport: () => string;
	nonexistentHierarchyCombinations: boolean;
	setNonexistentHierarchyCombinations: (
		nonexistentHierarchyCombinations: boolean
	) => void;
	status?: ViewTableStatus;
}
export type ICellsEdit<Type> = Record<string, ICellEdit<Type>>;
export const totalItemsPageList = [10, 50, 100, 500, 1000, 5000];
